<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <SportipsButton backButton chevronLeft>Retour</SportipsButton>
            <div class="text-h5 my-3 font-weight-bold">Liens d'inscription privilégiés</div>

            <LienVIPCreateForm></LienVIPCreateForm>

            <ListLienVIP></ListLienVIP>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LienVIPCreateForm from "@/components/Administration/Lien_VIP/LienVIPCreateForm.vue";
import ListLienVIP from "@/components/Administration/Lien_VIP/ListLienVIP.vue";
export default {
  components: { LienVIPCreateForm, ListLienVIP },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {

  },
};
</script>

<style lang="scss" scoped></style>